import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';

const MiniWidget = (props) => {
  // Default options and series in case they're missing
  const defaultOptions = {
    chart: { sparkline: { enabled: true } },
    stroke: { curve: 'smooth', width: 2 },
    colors: ['#f1b44c'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [25, 100, 100, 100],
      },
    },
    tooltip: {
      fixed: { enabled: false },
      x: { show: false },
      marker: { show: false },
    },
  };

  const defaultSeries = [{ name: 'Data', data: [0] }];

  return (
    <React.Fragment>
      {(Array.isArray(props.reports) ? props.reports : []).map((report, key) => (
        <Col sm="4" key={key}>
          <Card>
            <CardBody>
              <p className="text-muted mb-4">
                <i
                  className={
                    (report?.icon || 'mdi mdi-chart-areaspline') +
                    ' h2 text-' +
                    (report?.color || 'primary') +
                    ' align-middle mb-0 me-3'
                  }
                />{' '}
                {report?.title || 'Untitled'}{' '}
              </p>

              <Row>
                <Col xs="6">
                  <div>
                    <h5>{report?.value ?? '0'}</h5>
                    <p className="text-muted text-truncate mb-0">
                      {report?.desc || 'No description'}{' '}
                      <i className={report?.arrowUpDown || 'mdi mdi-arrow-up ms-1 text-success'} />
                    </p>
                  </div>
                </Col>
                <Col xs="6">
                  <div>
                    <ReactApexChart
                      options={report?.options || defaultOptions}
                      series={report?.series || defaultSeries}
                      type="area"
                      height={40}
                      className="apex-charts"
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      ))}
    </React.Fragment>
  );
};

export default MiniWidget;

MiniWidget.propTypes = {
  reports: PropTypes.array,
};

MiniWidget.defaultProps = {
  reports: [],
};